import { TheoryCourse } from "../providers/coursesProvider";
import { Button } from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import { useDialog } from "../hooks/useDialog";
import { AddAppointmentDialog } from "../dialogs/AddAppointmentDialog/AddAppointmentDialog";

export function AddTheoryLessonToCourseButton({ course }: { course: TheoryCourse }) {
  const { dialogProps, openDialog } = useDialog();
  return (
    <>
      <Button
        variant="outlined"
        sx={{ height: "40px" /* ... same height as <AddStudentToCourseButton> */ }}
        startIcon={<AddIcon />}
        onClick={openDialog}
      >
        Termin
      </Button>
      <AddAppointmentDialog {...dialogProps} tabs={["theoryLesson"]} courseId={course.id} />
    </>
  );
}
